module.exports = __webpack_public_path__ + "img/elementary-school-course-description-2.c48c5760.svg";